// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__MbTxY","search":"Header_search__1IyxK","singOut":"Header_singOut__3S5aS"};